/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { assignUserRoleResponseDataRoleSchema } from './AssignUserRoleResponseDataRoleSchema'

export const assignUserRoleResponseDataSchema = z.object({
	role: assignUserRoleResponseDataRoleSchema,
})

export type AssignUserRoleResponseDataSchema = z.infer<typeof assignUserRoleResponseDataSchema>
